import { useEffect, useRef } from 'react';

export interface UsePollingOptions {
  pollingFunction: () => void;
  interval?: number;
  shouldPoll: boolean;
  dependencies?: any[];
}

export function usePolling({
  pollingFunction,
  interval = 5000,
  shouldPoll,
  dependencies = [],
}: UsePollingOptions) {
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const startPolling = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    intervalRef.current = setInterval(pollingFunction, interval);
  };

  const stopPolling = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  useEffect(() => {
    if (shouldPoll) {
      startPolling();
    } else {
      stopPolling();
    }

    // Cleanup function to stop polling when the component unmounts or conditions change
    return () => stopPolling();
  }, [shouldPoll, interval, ...dependencies]);

  return {
    startPolling,
    stopPolling,
    isPolling: shouldPoll && intervalRef.current !== null,
  };
}
